module.exports = __webpack_public_path__ + "img/-s-pic_product zdyw_NO 07.3340bdee.svg";